
export const CONTACT_GREETING_DEFAULTS: Record<string, string> = {
  doctor: 'Hi, I found your CommonQR profile and would like to book an appointment.',
  dentist: 'Hi, I found your CommonQR profile and would like to book an appointment.',
  pharmacist: 'Hi, I found your CommonQR profile and would like to enquire about your services.',
  physiotherapist: 'Hi, I found your CommonQR profile and would like to book a session.',
  psychologist: 'Hi, I found your CommonQR profile and would like to book a consultation.',
  veterinarian: 'Hi, I found your CommonQR profile and would like to book an appointment.',
  lawyer: 'Hi, I came across your CommonQR profile and would like to discuss your services.',
  ca_auditor: 'Hi, I came across your CommonQR profile and would like to book a consultation.',
  financial_advisor: 'Hi, I came across your CommonQR profile and would like to discuss your services.',
  insurance_agent: 'Hi, I came across your CommonQR profile and would like to get a quote.',
  real_estate_agent: 'Hi, I found your CommonQR profile and would like to enquire about your listings.',
  consultant: 'Hi, I came across your CommonQR profile and would like to discuss your services.',
  architect: 'Hi, I came across your CommonQR profile and would like to discuss a project.',
  engineer: 'Hi, I came across your CommonQR profile and would like to get a quote.',
  coach_mentor: 'Hi, I found your CommonQR profile and would like to book a session.',
  restaurant: 'Hi, I scanned your CommonQR and would like to make a reservation.',
  cafe_bakery: 'Hi, I found your CommonQR profile and would like to place an order.',
  hotel_resort: 'Hi, I found your CommonQR profile and would like to enquire about availability.',
  event_venue: 'Hi, I found your CommonQR profile and would like to enquire about your venue.',
  catering: 'Hi, I found your CommonQR profile and would like to request a catering quote.',
  store: 'Hi, I found your CommonQR profile and would like to enquire about your products.',
  salon_barber: 'Hi, I found your CommonQR profile and would like to book an appointment.',
  spa_wellness: 'Hi, I found your CommonQR profile and would like to book a treatment.',
  gym_fitness: 'Hi, I found your CommonQR profile and would like to know more about membership.',
  yoga_meditation: 'Hi, I found your CommonQR profile and would like to book a class.',
  nutritionist: 'Hi, I found your CommonQR profile and would like to book a consultation.',
  photographer: 'Hi, I came across your CommonQR profile and would like to discuss a shoot.',
  videographer: 'Hi, I came across your CommonQR profile and would like to discuss a project.',
  artist_designer: 'Hi, I came across your CommonQR profile and would like to enquire about your work.',
  musician_dj: 'Hi, I came across your CommonQR profile and would like to discuss a booking.',
  content_creator: 'Hi, I came across your CommonQR profile and would like to collaborate.',
  podcaster: 'Hi, I came across your CommonQR profile and would like to connect.',
  writer_author: 'Hi, I came across your CommonQR profile and would like to connect.',
  teacher_tutor: 'Hi, I found your CommonQR profile and would like to book a trial class.',
  school_institute: 'Hi, I found your CommonQR profile and would like to enquire about enrolment.',
  training_centre: 'Hi, I found your CommonQR profile and would like to enquire about your courses.',
  electrician: 'Hi, I found your CommonQR profile and would like to request a quote.',
  plumber: 'Hi, I found your CommonQR profile and would like to request a quote.',
  carpenter: 'Hi, I found your CommonQR profile and would like to request a quote.',
  driver_logistics: 'Hi, I found your CommonQR profile and would like to request a delivery.',
  business: 'Hi, I came across your CommonQR profile and would like to get in touch.',
  startup: 'Hi, I came across your CommonQR profile and would like to connect.',
  ngo_trust: 'Hi, I came across your CommonQR profile and would like to know more.',
  government: 'Hi, I found your CommonQR profile and would like to enquire about your services.',
  personal: 'Hi, I came across your CommonQR profile and would like to connect.',
  freelancer: 'Hi, I came across your CommonQR profile and would like to discuss a project.',
  student: 'Hi, I came across your CommonQR profile and would like to connect.',
};

export const CONTACT_GREETING_FALLBACK = 'Hi, I came across your CommonQR profile and would like to connect.';

export function getContactGreetingDefault(profileType: string): string {
  return CONTACT_GREETING_DEFAULTS[profileType] ?? CONTACT_GREETING_FALLBACK;
}

export function resolveContactGreeting(profileType: string, customGreeting?: string | null): string {
  return customGreeting?.trim() || getContactGreetingDefault(profileType);
}
